import { Button, Stack } from "@mui/material";

import type { PollWithOptions } from "../../../../../poll/server/supabase-poll-service";
import type { FC } from "react";

export const NonCustomPollComponent: FC<{
  poll: PollWithOptions;
}> = ({ poll }) => (
  <Stack
    direction="row"
    spacing={0}
    sx={{ border: "1px solid #D1D5DB", borderRadius: 1, overflow: "hidden" }}
  >
    {poll.poll.options.map(({ text }, index) => (
      <Button
        variant="outlined"
        fullWidth
        sx={{
          flex: 1,
          borderRadius: 0,
          borderLeft: index !== 0 ? "1px solid #ccc" : "none",
          borderTop: "none",
          borderBottom: "none",
          borderRight: "none",
          textTransform: "none",
          color: "#121828",
          backgroundColor: "#ffffff",
        }}
        data-analytics-id={`poll-answer-option-${text}`}
        key={`poll-answer-option-${text}`}
      >
        {text}
      </Button>
    ))}
  </Stack>
);
